module.exports = __webpack_public_path__ + "static/media/city1.ebc5562d.jpg";